import React, { useEffect, useState } from 'react';
import Icon from '../../../Icon/Icon';
import { useTranslation } from 'react-i18next';
import Block from './Block';
import Item from './Item';
import { useAuth } from '../../../../containers/UseAuth';
import { useForecast } from '../../../../contexts/ForecastContext';
import {
    formatCoveragePercent,
    formatCurrencyValue,
    formatDecimal,
    formatFrequency,
} from '../../../../utils/formatForecastNumber';

const Audiences = ({ isLoading, selectedCurrency }) => {
    const auth = useAuth();
    const { t } = useTranslation();
    const { forecast: metrics = {} } = useForecast();
    const targetMetrics = metrics.targetMetrics || {};
    const targetImpacts = Number(targetMetrics.totalImpacts) || 0;
    const cpi = targetImpacts
        ? Number(metrics.spentBudget || 0) / targetImpacts
        : 0;
    const currencyCode = selectedCurrency?.short_name?.toUpperCase() || 'USD';

    const [seeImpressions, setSeeImpressions] = useState(false);
    useEffect(() => {
        let adminOrSupervising = auth.isAdmin() || auth.isSupervising();
        setSeeImpressions(adminOrSupervising);
    }, []);

    return (
        <div>
            <Block
                icon={
                    <Icon
                        name="users-class"
                        fixedWidth
                        size="lg"
                        className="m-1 mr-2 text-blue-300"
                    />
                }
                title={t(
                    'sections.campaigns.new-campaign.wizard-audiences.forecast.forecast'
                )}>
                <Item
                    isLoading={isLoading === true}
                    title={t(
                        'sections.campaigns.new-campaign.wizard-audiences.forecast.targeted-universe'
                    )}>
                    {formatDecimal(metrics.targetUniverse)}
                </Item>

                <Item
                    isLoading={isLoading === true}
                    title={t(
                        'sections.campaigns.new-campaign.wizard-audiences.forecast.targeted-impacts'
                    )}>
                    {formatDecimal(targetMetrics.totalImpacts)}
                </Item>

                <Item
                    isLoading={isLoading === true}
                    title={t(
                        'sections.campaigns.new-campaign.wizard-audiences.forecast.coverage'
                    )}>
                    <span>
                        {formatCoveragePercent(targetMetrics.coverage)}
                        <span className="text-xs text-gray-500 block">
                            {formatDecimal(targetMetrics.coverageNumericAmount)}
                        </span>
                    </span>
                </Item>

                <Item
                    isLoading={isLoading === true}
                    title={t(
                        'sections.campaigns.new-campaign.wizard-audiences.forecast.GRP'
                    )}>
                    {formatDecimal(targetMetrics.grp)}
                </Item>

                <Item
                    isLoading={isLoading === true}
                    title={t(
                        'sections.campaigns.new-campaign.wizard-audiences.forecast.frequency'
                    )}>
                    {formatFrequency(targetMetrics.frequency)}
                </Item>
                <Item isLoading={isLoading === true} title={'CPM'}>
                    {formatCurrencyValue(targetMetrics.cpm, currencyCode)}
                </Item>

                {seeImpressions && (
                    <Item
                        isLoading={isLoading === true}
                        title={t(
                            'sections.campaigns.new-campaign.wizard-audiences.forecast.ad-impressions'
                        )}>
                        {formatDecimal(metrics.adImpressions)}
                    </Item>
                )}
                {seeImpressions && (
                    <Item
                        isLoading={isLoading === true}
                        title={t(
                            'sections.campaigns.new-campaign.wizard-audiences.forecast.cost-per-impact'
                        )}>
                        {formatCurrencyValue(cpi, currencyCode)}
                    </Item>
                )}
            </Block>
        </div>
    );
};

export default Audiences;
